module.exports = __webpack_public_path__ + "static/media/a10_lighting.afbc3adf.png";